import { render } from "./InvoiceCalculation.vue?vue&type=template&id=1053ad51&scoped=true&ts=true"
import script from "./InvoiceCalculation.vue?vue&type=script&lang=ts"
export * from "./InvoiceCalculation.vue?vue&type=script&lang=ts"

import "./InvoiceCalculation.vue?vue&type=style&index=0&id=1053ad51&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1053ad51"]])

export default __exports__